import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageTitle } from "@/lib/pageTitle";

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    const title = pageTitle ? `Round Table - ${pageTitle}` : "Round Table";
    document.title = title;
  }, [location.pathname]);

  return null;
};

export default TitleUpdater;
